import React, {useContext, useState} from 'react';
import {FloorPlanOption, OptionValue} from "../SharedTypes";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import {CartContext} from "./CartContext";
import OptionValueDialog from "./OptionValueDialog";
import {getPriceDesc} from "../shared";

const useStyles = makeStyles(theme => ({
    container: {
        padding: theme.spacing(2),
        textAlign: 'left'
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    optionImage: {
        display: 'block',
        maxWidth: 180,
        maxHeight: 120,
        margin: 'auto'
    },
    optionText: {
        textAlign: 'center',
        margin: 'auto',
        maxWidth: 180,
    },
    noOptions: {
        margin: theme.spacing(4),
        textAlign: 'center',
    }
}));

export default function OptionSelect({floorPlanOption, onBack, options}: {
    floorPlanOption: FloorPlanOption, onBack(): void, options: FloorPlanOption[]
}) {
    const classes = useStyles(),
        [selectedOption, setSelectedOption] = useState<OptionValue | undefined>(),
        {cartItems, dispatchCartItemAction} = useContext(CartContext);

    return <div className={classes.container}>
        <div dangerouslySetInnerHTML={{__html: floorPlanOption?.description || ''}}/>
        <Grid container spacing={2}>
            {floorPlanOption.values.length
                ? floorPlanOption.values.map((option, index) =>
                    <Grid item key={index} xs={12} sm={6} lg={4}>
                        <Link style={{cursor: 'pointer'}} onClick={() => setSelectedOption(option)}>
                            <img src={option.photo.url || 'https://place-hold.it/300x300/777'} alt={option.name} className={classes.optionImage}/>
                            <div className={classes.optionText}>
                                {option.name}{getPriceDesc(option) ? ` (${getPriceDesc(option)})` : ''}
                            </div>
                        </Link>
                    </Grid>)
                : <Grid item xs={12} className={classes.noOptions}>
                    <Typography variant="subtitle1" color="textSecondary" component="span">No Options</Typography>
                </Grid>}
        </Grid>
        <OptionValueDialog floorPlanOption={floorPlanOption} optionValue={selectedOption}
                           onCancel={() => setSelectedOption(undefined)}
                           onSave={(fieldData) => {
                               if (selectedOption) {
                                   const index = cartItems.findIndex(item => item.optionValue === selectedOption);
                                   if(index > -1) {
                                       dispatchCartItemAction({
                                           type: 'UpdateItem', index,
                                           item: {floorPlanOption, optionValue: selectedOption, fieldData}
                                       });
                                   } else {
                                       dispatchCartItemAction({
                                           type: 'AddItem',
                                           item: {floorPlanOption, optionValue: selectedOption, fieldData},
                                           options
                                       });
                                   }
                                   setSelectedOption(undefined);
                               }
                               onBack();
                           }}/>
    </div>;
};